<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    Shops list
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">docs</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="'' != errorMessage"> {{ errorMessage }} </alert-fail>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="pagination.currentPage"
                          :per-page="pagination.numberPerPage"
                          class="table-privilege"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectable
                          selectedVariant="single"
                          :fields="fields"
                          :items="shops">
                          <template slot="logo" slot-scope="row">
                            <img class="logo" :src="row.item.logo || '/images/101/thumbnail.png'" alt="Thumbnail">
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                    <b-col>
                        <app-paging
                            :totalRows="pagination.totalRows"
                            :page="pagination.currentPage"
                            @changePage="changePage"/>
                    </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import AppPaging from '../../components/Pagination.vue';
import AlertFail from '../../components/alert/AlertFail';

export default {
  data () {
    return {
      errorMessage: '',
      isBusy: false,
      isLoading: false,
      shops: [],
      fields: [
        { key: 'logo' },
        { key: 'name' }
      ],
      pagination: {
        currentPage: 1,
        numberPerPage: process.env.VUE_APP_NUMBER_PER_PAGE,
        totalRows: 30
      }
    };
  },
  methods: {
    viewDetails (e) {
      this.$router.push({ name: '101shops-details', params: { id: e.id } });
    },
    changePage (e) {
      this.pagination.currentPage = e;
      this.getData();
    },
    handleError (error) {
      this.errorMessage = error.response ? error.response.data : error.message;
    },
    getData () {
      this.isBusy = true;
      this.axios.get(process.env.VUE_APP_URL_MQDC_API + '/shops', { headers: { Accept: 'application/json' } })
        .then(response => {
          const data = response.data.data;
          this.pagination.totalRows = data.length;
          if (data) {
            data.forEach(shop => {
              this.shops.push({
                id: shop.id,
                logo: shop.logo,
                name: shop.name
              });
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          this.handleError(error);
        });
    }
  },
  computed: {
    totalRows () {
      return this.shops.length;
    }
  },
  mounted () {
    this.getData();
  },
  components: {
    'app-paging': AppPaging,
    AlertFail
  }
};
</script>

<style scoped>
    .logo{
        max-width: 75px;
        max-height: 75px;
    }
</style>
